export default function handleVoidLabelResponseNotification(
	rootstore,
	response,
	fulfillmentOrderId,
	voidOnCarrierOrChannel = true
) {
	if (response) {
		if (response.cancelledShipment) {
			if (response.voidedInternally) {
				rootstore.notificationStore.success(['VOIDLABELVIEW.SUCCESS', { id: fulfillmentOrderId }]);
			} else {
				// Voided on Carrier/Channel but failed to void internally
				rootstore.notificationStore.warning(['VOIDLABELVIEW.CARRIERSUCCESS', { id: fulfillmentOrderId }]);
			}
		} else {
			if (response.voidedInternally) {
				if (voidOnCarrierOrChannel) {
					// Voided Internally but failed to void on carrier/channel
					rootstore.notificationStore.warning([
						'VOIDLABELVIEW.ERRORONAPI',
						{ id: fulfillmentOrderId, notification: response.message },
					]);
				} else {
					// Void on channel was not selected
					rootstore.notificationStore.success(['VOIDLABELVIEW.SUCCESS', { id: fulfillmentOrderId }]);
				}
			} else {
				// Failed to void on Carrier/Channel and Internally
				rootstore.notificationStore.error(['VOIDLABELVIEW.ERROR', { id: fulfillmentOrderId }]);
			}
		}
	} else {
		rootstore.notificationStore.error(['VOIDLABELVIEW.ERROR', { id: fulfillmentOrderId }]);
	}
}
